import { render } from "./LeaderboardPlayerItem.vue?vue&type=template&id=71a6bad8&scoped=true&ts=true"
import script from "./LeaderboardPlayerItem.vue?vue&type=script&lang=ts"
export * from "./LeaderboardPlayerItem.vue?vue&type=script&lang=ts"

import "./LeaderboardPlayerItem.vue?vue&type=style&index=0&id=71a6bad8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a6bad8"]])

export default __exports__